import { Component, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { BaseCommonComponent, BaseDataService, UserService, ModalService, NotificationService } from 'yt-ng-framework';
// import { ToastrService } from 'ngx-toastr';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'yt-uplata',
  templateUrl: './uplata.component.html'
})
export class UplataComponent extends BaseCommonComponent implements OnInit{

submitted = false;
  @Input() Parameters;
  nazivLabele1 = "";
  nazivLabele2 = "";

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected activeModal: NgbActiveModal,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected userService: UserService,
    protected modalService: ModalService,
  ) { 
    super(activatedRoute, userService, baseDataService, translateService, modalService,toastrService);

  }


  ngOnInit() {
    let date = new Date();
    let ngbDate = new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
    this.baseFormGroup = new FormGroup({
      DatumUplate: new FormControl(ngbDate),
      IznosUplate: new FormControl(0.00),
    })



    // let isAcceptParam = this.Parameters.find(p => p != null && p.Name === 'accept');
    let isAccept = false;

    // if (isAcceptParam) {
    //   isAccept = isAcceptParam.Value === true; 
    // }

 setTimeout(() => {
    //  if (!isAccept) {         
    //  this.addValidatorToFc("Napomena1",Validators.required,'required',"COMMENT.REJECT.REASON.VALIDATION.REQUIRED");
    //  this.addValidatorToFc("Napomena1", Validators.maxLength(500), 'maxlength', 'COMMENT.RAZLOG.VALIDATION.MAXLENGTH');
    //  } else {
    //     this.baseFormGroup.get('Napomena1').clearValidators();
    //   }
    //     this.baseFormGroup.get('Napomena1').updateValueAndValidity();
    });
  }
  
  onDatumChange(value) {
    if (value != null) {
        //Ovde treba da proveri da li je već evidentiran neki iznos uplate na taj datum za taj račun kako bi se taj iznos ponudio na izmenu
    }
  }


  Close(){
    this.activeModal.close();
  }

  Ok(){
    this.submitted = true;

    if (this.baseFormGroup.valid) {
      let datumUplate = this.baseFormGroup.get('DatumUplate').value;
      let iznosUplate = this.baseFormGroup.get('IznosUplate').value;

      this.activeModal.close({ datum: datumUplate, iznos: iznosUplate });
    }
  }

}  
